module.exports = __webpack_public_path__ + "img/failed.058226f9.jpg";